/* eslint-disable */
import React, { useContext, useEffect, useRef, useState } from 'react';
import CallSecondLayout from './CallSecondLayout';
import CallThirdLayout from './CallThirdLayout';


const CallLayout = ({ dynamicButtonDivs, dynamicDivs, selectedLayout, handleMouseUpFunction }) => {
  

  return (
    
    <div
      id="ST1"
      style={{
        display: 'flex',
        flexDirection: selectedLayout === 'T6' || selectedLayout === 'T5' ? 'column' : selectedLayout === 'T4' ? 'row-reverse' : null,
        width: '100%',
        height: '100%',
        backgroundColor: 'transparent'
      }}
    >
      
      <div
        id="STG1"
        style={{
          display: 'flex',
          flex: 1,
          flexDirection: 'row',
          width: '100%',
          height: '100%',
          overflow: 'hidden'
        }}
        dataGroup='layout'
      >
        <div
          stgId='STG1'
          id="SC00"
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            borderRadius: '10px',
            boxShadow: '0 0px 4px rgba(0, 0, 0, 0.1)', // Add a box shadow

          }}
          dataMoveUpId='SC00'
          dataGroup='main'
          onMouseUp={e => handleMouseUpFunction(e)}
        >
          
          <div
            id="SC00-B"
            stgId='STG1'
            style={{
              width: '100%',
              flex: 0.2,
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'wrap',
            }}
            dataMoveUpId='SC00'
            dataGroup='header'
            onMouseUp={e => handleMouseUpFunction(e)}
          >
            {dynamicButtonDivs}
          </div>
          <div
            id="SC00-C"
            stgId='STG1'
            style={{
              width: '100%',
              display: 'grid',
              overflow: 'auto',
              flex: 5,
              backgroundColor: '#f5f5f5'
            }}
            dataMoveUpId='SC00'
            dataGroup='contentWrapper'
            onMouseUp={e => handleMouseUpFunction(e)}
          >
            {dynamicDivs}
          </div>
        </div>
      </div>
      <div style={{flex: 1,
      display: selectedLayout === 'T1' ? 'none' : selectedLayout === 'T2' ? 'flex' :  selectedLayout === 'T3' ? 'flex' : 'flex',
      flexDirection: selectedLayout === 'T3' || selectedLayout === 'T4' ? 'column' : selectedLayout === 'T6' ? 'row' :  null,
      }}>
      <div id='STG2' style={{    display: 'flex',
          flexDirection: 'row',
          width: '100%',
          height: '100%',
          flex: 1,
          overflow: 'hidden'}}
          
          dataGroup='layout'
          >
          <CallSecondLayout
              dynamicButtonDivs={dynamicButtonDivs}
              dynamicDivs={dynamicDivs}
              handleMouseUpFunction={handleMouseUpFunction}
            />
      </div>
      <div id='STG3' style={selectedLayout === 'T3' || selectedLayout ==='T6'  || selectedLayout === 'T4'? {    display: 'flex',
          flexDirection: 'row',
          width: '100%',
          height: '100%',
          flex: 1,
          overflow: 'hidden'} : {display: 'none'}}
          dataGroup='layout'
          >
          <CallThirdLayout
              dynamicButtonDivs={dynamicButtonDivs}
              dynamicDivs={dynamicDivs}
              handleMouseUpFunction={handleMouseUpFunction}
            />
      </div>
      </div>
    </div>
  );
};

export default CallLayout;